import React from 'react';
import FAQComponent  from '../components/FAQComponent';
import TopBar  from '../components/Topbar';
import { MyProSidebarProvider } from "../components/SidebarContext";

const FAQ = () => {
  return(
    <MyProSidebarProvider>
      {localStorage.getItem("codefussion-login-token") === null ? window.location.replace("/login") :
      <FAQComponent />
      }
      <a href="https://api.whatsapp.com/send?phone=+2348084914979&text=Hello" className="float" target="_blank">
      <i class="fab fa-whatsapp my-float"></i>
      </a>
    </MyProSidebarProvider>
  )
}

export default FAQ
